import { compose } from 'redux';

export default (...middlewares) => store => compose(
  ...middlewares.map(middleware => middleware(store)),
);
